import { TenantType } from "../tenant/TenantType";

export const ClientTypeEnum = {
  FEED: "Feed",
  ATS: "ATS",
} as const;

export type ClientTypeEnum =
  (typeof ClientTypeEnum)[keyof typeof ClientTypeEnum];

export const PaymentTypeEnum = {
  SUBSCRIPTION: "Subscription",
  POST_PAID: "Postpaid",
} as const;
export type PaymentTypeEnum =
  (typeof PaymentTypeEnum)[keyof typeof PaymentTypeEnum];

export const paymentTypeMap: Record<PaymentTypeEnum, string> = {
  [PaymentTypeEnum.SUBSCRIPTION]: "Subscription",
  [PaymentTypeEnum.POST_PAID]: "Postpaid",
};

export interface ClientType {
  additionalDescriptionHeader: string;
  allocableBudget: number;
  allocableBudgetWithoutOverspend: number;
  allocatedBudget: number;
  clientDescriptionHeader: string;
  clientType: ClientTypeEnum;
  currentBudget: number;
  emailAddress: string;
  feedFormat: string;
  feedUrl: string;
  firstName: string;
  for: string;
  functionDescriptionHeader: string;
  id: number;
  id2: string;
  imagePath: string;
  indeedEnabled: boolean;
  infix?: string;
  invoiceOnlineResult: boolean;
  isHeaderEnabled: boolean;
  jobTitle: string;
  lastName: string;
  marginIncluded: boolean;
  monthlyBudget: number;
  name: string;
  offerDescriptionHeader: string;
  overspendAllowed: boolean;
  paymentType: PaymentTypeEnum;
  percentage: string;
  phoneNumber: string;
  recruitNowApiKey: string;
  recruitNowUrl: string;
  recruitNowWebhookId?: string | null;
  recruitNowWebhookSecret?: string | null;
  requirementsDescriptionHeader: string;
  status: boolean;
  summaryHeader: string;
  tenant?: TenantType;
  tenantId: string | null;
  webhookEnabled: boolean;
  hasDirectApplyEnabled: boolean;
  isSelfService: boolean;
  lastSyncDate?: string | null;
}

export interface ClientErrorObject {
  propertyName: string;
  errorMessage: string;
}
